import CityPageTemplate from "../city-template/CityPageTemplate";
import { middlesboroughConfig } from "./data";

export default function MiddlesboroughPage() {
  return <CityPageTemplate config={middlesboroughConfig} />;
}